<template>
	<div class="work" id="work-2">
		<h2 class="title"><span>07</span>SCE  - Delivery Control System</h2>
		<div class="subtitle">
			<h3><span>Year</span>2017</h3>
			<h3><span>Product</span>App</h3>
			<h3><span>Technology</span>Phonegap</h3>
		</div>
		<blockquote>
			The "SCE" is an app that monitors deliveries, has a rating system for the service and order check.
		</blockquote>
		<figure>
			<figcaption>
				<h3>Objective</h3>
				<p>The main goal for this app was being able to do the time check, efficiency and identify any occurrences in the delivery.</p>
				<h3>My roles</h3>
				<p>My roles were creating the user flow of the platform, the interface design, usability testing, front-end development in HTML/CSS and JavaScript interactions.</p>
			</figcaption>
			<span>
				<img src="../../assets/desk_sce-1.png" alt="SCE app"/>
			</span>
		</figure>
		<figure class="half">
			<figcaption>
				<h3>The Problem</h3>
				<p>Create a user flow that would be simple and quick to be used for truck drivers. This user are busy people, who have a tight agenda for deliveries, most of the time don't have good reception on their devices and are using gloves, which impacts on the touching points in the screens. Thinking in ways that would make them not taking off was important to increase satisfaction in the use. </p>
			</figcaption>
			<img src="../../assets/sce-1.jpg" alt="SCE app"/>
			<img src="../../assets/sce-2.jpg" alt="SCE app"/>
		</figure>
		<figure class="half">
			<img src="../../assets/sce-3.jpg" alt="SCE app"/>
			<img src="../../assets/sce-4.jpg" alt="SCE app"/>
			<figcaption>
				<h3>The Solution</h3>
				<p>For this concept I used the concept of ready-to-use, always having only one button in the interface for the actions in the delivery process and, in the navigation, always presenting three interactions maximum to the user.  By doing this, I optimized the flow for the app for the delivery sequence. That made the app lighter (which was important for the poor receptions), more assertive in the usability (there was less space for errors) and for an easy understanding of the user.</p>
			</figcaption>
		</figure>
		<figure class="half">
			<figcaption></figcaption>
			<img src="../../assets/sce-5.jpg" alt="SCE app"/>
			<img src="../../assets/sce-6.jpg" alt="SCE app"/>
		</figure>
	</div>
</template>
<script>
export default {
	data() {
		return {

		}
	},
	methods: {
		handleScroll() {
			let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
			if (bottomOfWindow) {
				document.getElementById('work-menu').classList.add('open');
			}
		}
	},
	created () {
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed () {
		window.removeEventListener('scroll', this.handleScroll);
	}
}
</script>